import React, { useMemo } from 'react';
import ProjectPreviewModalContext from './ProjectPreviewModalContext';
import { ProjectPreviewModalProviderProps } from './types';

const ProjectPreviewModalProvider: React.FC<ProjectPreviewModalProviderProps> = ({
  projectId,
  widgetId,
  embedConfig,
  fileArchiveInfo,
  embedVideoId,
  projectLatestRegeneration,
  isUCSCompatible,
  children,
}) => (
  <ProjectPreviewModalContext.Provider
    value={useMemo(
      () => ({
        projectId,
        widgetId,
        embedConfig,
        fileArchiveInfo,
        embedVideoId,
        projectLatestRegeneration,
        isUCSCompatible,
      }),
      [
        projectId,
        widgetId,
        embedConfig,
        fileArchiveInfo,
        embedVideoId,
        projectLatestRegeneration,
        isUCSCompatible,
      ],
    )}
  >
    {children}
  </ProjectPreviewModalContext.Provider>
);

export default ProjectPreviewModalProvider;
